import {EntityResourceIds} from '@dms/api/shared';

export type TaskRelations = Extract<
  EntityResourceIds,
  | EntityResourceIds.customer
  | EntityResourceIds.vehicle
  | EntityResourceIds.businessCase
  | EntityResourceIds.interest
  | EntityResourceIds.serviceCase
  | EntityResourceIds.directSale
  | EntityResourceIds.tireOrder
  | EntityResourceIds.workshopInterest
>;
